"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventMapping = void 0;
const tslib_1 = require("tslib");
const web_embed_api_1 = tslib_1.__importStar(require("@formsort/web-embed-api"));
const react_1 = tslib_1.__importStar(require("react"));
exports.eventMapping = {
    onUnauthorized: 'unauthorized',
    onRedirect: 'redirect',
    onFlowLoaded: web_embed_api_1.SupportedAnalyticsEvent.FlowLoaded,
    onFlowClosed: web_embed_api_1.SupportedAnalyticsEvent.FlowClosed,
    onFlowFinalized: web_embed_api_1.SupportedAnalyticsEvent.FlowFinalized,
    onStepLoaded: web_embed_api_1.SupportedAnalyticsEvent.StepLoaded,
    onStepCompleted: web_embed_api_1.SupportedAnalyticsEvent.StepCompleted,
};
const attachEventListenersToEmbed = (embed, events) => {
    for (const [reactEventName, listener] of Object.entries(events)) {
        const embedEventName = exports.eventMapping[reactEventName];
        embed.addEventListener(embedEventName, listener);
    }
};
const onMount = (containerRef, props) => {
    const containerElement = containerRef.current;
    if (!containerElement) {
        return;
    }
    const { clientLabel, flowLabel, variantLabel, embedConfig, responderUuid, formsortEnv, queryParams = [] } = props, eventListeners = tslib_1.__rest(props, ["clientLabel", "flowLabel", "variantLabel", "embedConfig", "responderUuid", "formsortEnv", "queryParams"]);
    const embed = (0, web_embed_api_1.default)(containerElement, embedConfig);
    attachEventListenersToEmbed(embed, eventListeners);
    if (responderUuid) {
        queryParams.push(['responderUuid', responderUuid]);
    }
    if (formsortEnv) {
        queryParams.push(['formsortEnv', formsortEnv]);
    }
    embed.loadFlow(clientLabel, flowLabel, variantLabel, queryParams.length ? queryParams : undefined);
    return embed;
};
const EmbedFlow = (props) => {
    var _a;
    const containerRef = (0, react_1.useRef)(null);
    const style = (_a = props.embedConfig) === null || _a === void 0 ? void 0 : _a.style;
    (0, react_1.useEffect)(() => {
        const embed = onMount(containerRef, props);
        return () => {
            embed === null || embed === void 0 ? void 0 : embed.unloadFlow();
        };
    }, []);
    return react_1.default.createElement("div", { ref: containerRef, style: style });
};
exports.default = EmbedFlow;
